import type { Edge } from 'react-native-safe-area-context';
import { StyleSheet, UnistylesRuntime } from 'react-native-unistyles';

import { type AppColors, theme as squireTheme } from '@squire/ui';

export const styles = StyleSheet.create((theme, rt) => ({
  background: (color: keyof AppColors = 'backgroundPrimary') => ({
    flex: 1,
    flexDirection: 'column',
    backgroundColor: theme[color],
    overflowX: 'hidden',
  }),
  container: (edges: Edge[]) => ({
    alignItems: 'center',
    paddingTop: edges.includes('top') ? rt.insets.top : 0,
    paddingBottom: edges.includes('bottom') ? rt.insets.bottom : 0,
    paddingLeft: edges.includes('left') ? rt.insets.left : 0,
    paddingRight: edges.includes('right') ? rt.insets.right : 0,
  }),
  scrollContent: {
    flexGrow: 1,
    width: '100%',
    alignItems: 'center',
  },
  content: {
    width: '100%',
    flex: 1,
    overflow: 'hidden',
    _web: {
      maxWidth: UnistylesRuntime.breakpoints.tablet,
    },
  },
  // Spans the viewport. The gutter only applies once the content column stops
  // filling the screen — below that the header already sits against the page's
  // own edges and adding padding here would shift it.
  fullWidthHeader: {
    width: '100%',
    paddingHorizontal: {
      default: 0,
      tablet: squireTheme.spacing[5],
    },
  },
}));
